import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

const CHAT_HEADER_HEIGHT = 60;

export const ChatHeaderBox = styled(Box).attrs(({ isChatBoxVisible }) => ({
  position: 'relative',
  horizontal: true,
  align: 'center',
  justify: 'space-between',
  width: '100%',
  height: CHAT_HEADER_HEIGHT,
  padding: '15px 12px',
  backgroundColor: 'background',
  borderRadius: isChatBoxVisible ? '5px 5px 0 0' : '5px',
}))`
  border-bottom: ${({ isChatBoxVisible, theme }) =>
    isChatBoxVisible ? `1px solid ${theme.colors.lightLineDivider}` : '0'};
`;

export const ChatHeader = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
  fontWeight: 'bold',
})``;

export const ToggleBox = styled(Box).attrs({
  position: 'relative',
  horizontal: true,
  align: 'center',
  flex: '0 0 auto',
})``;

export const ToggleButton = styled(Box).attrs({
  align: 'center',
  justify: 'center',
  width: '24px',
  height: '24px',
  margin: 0,
  backgroundColor: 'background',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'heavyLineOutline',
  borderRadius: '5px',
  cursor: 'pointer',
})`
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightLineDivider};
  }
`;
